export let Gender = /*#__PURE__*/function (Gender) {
  Gender["F"] = "F";
  Gender["M"] = "M"; // O = "O",
  return Gender;
}({});